
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import LegalWrapper from "components/LegalWrapper";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = LegalWrapper
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Impressum`}</h1>
    <h2>{`Angaben gemäß § 5 TMG:`}</h2>
    <p>{`SB Konzept GmbH`}<br parentName="p"></br>{`
`}{`Am Söldnermoos 6`}<br parentName="p"></br>{`
`}{`85399 Hallbergmoos`}</p>
    <h2>{`Vertreten durch:`}</h2>
    <p>{`Felix Eigenbrodt`}<br parentName="p"></br>{`
`}{`Ronnie Eigenbrodt`}</p>
    <h2>{`Kontakt:`}</h2>
    <p>{`Telefon: +49 (0) 811 - 541 556 0`}<br parentName="p"></br>{`
`}{`Telefax: +49 (0) 811 - 541 556 20`}<br parentName="p"></br>{`
`}{`E-Mail: `}<a parentName="p" {...{
        "href": "mailto:info@sb-konzept.de"
      }}>{`info@sb-konzept.de`}</a></p>
    <h2>{`Registereintrag:`}</h2>
    <p>{`Eintragung im Handelsregister.`}<br parentName="p"></br>{`
`}{`Registergericht:Amtsgericht München`}<br parentName="p"></br>{`
`}{`Registernummer: HRB 77268`}</p>
    <h2>{`Umsatzsteuer:`}</h2>
    <p>{`Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:`}<br parentName="p"></br>{`
`}{`DE129456142`}</p>
    <h2>{`Streitschlichtung`}</h2>
    <p>{`Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: `}<a parentName="p" {...{
        "href": "https://ec.europa.eu/consumers/odr"
      }}>{`https://ec.europa.eu/consumers/odr`}</a>{` .`}<br parentName="p"></br>{`
`}{`Unsere E-Mail-Adresse finden Sie oben im Impressum.`}</p>
    <p>{`Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.`}</p>
    <h3>{`Haftung für Inhalte`}</h3>
    <p>{`Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.`}</p>
    <p>{`Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.`}</p>
    <h3>{`Haftung für Links`}</h3>
    <p>{`Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.`}</p>
    <p>{`Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.`}</p>
    <h3>{`Urheberrecht`}</h3>
    <p>{`Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.`}</p>
    <p>{`Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;